import { createStorage, IStorage, IStorageDefinition } from '/storage';

export const useStorage = (definition?: IStorageDefinition): IStorage => {
  return createStorage(definition);
};
